import "./styles.scss";

import { useTranslation } from "react-i18next";

import DetailsCard from "components/DetailsCard";
import NeedHelp from "../NeedHelp";
import MostSearched from "../MostSearched";
import ScrollTopMobile from "components/ScrollTopMobile";

import useResponsive from "libs/helpers/useResponsive";

const mainClass = "faq-content-aside";

const FaqContentAside = () => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  return (
    <>
      <div className={mainClass}>
        {!max.sm && (
          <div>
            <DetailsCard title={t("Others also frequently searched for")}>
              <MostSearched />
            </DetailsCard>
          </div>
        )}
        <div>
          <NeedHelp />
        </div>
      </div>
      {max.sm && <ScrollTopMobile />}
    </>
  );
};

export default FaqContentAside;
